export default {
    userInfo:null,
    validPlatAccount:null,
    footerInfo: {},
    securityConfig: {}
}
